import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var PermissionManagementRoutes = {
    [`/user-management/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.user-management",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | User Management"
            }
        ],
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission_management"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./permission-management.module.js");
                }
            }
        ]
    }
}